import { render } from "./VDivider.vue?vue&type=template&id=7c8c977b&scoped=true"
import script from "./VDivider.vue?vue&type=script&lang=js"
export * from "./VDivider.vue?vue&type=script&lang=js"

import "./VDivider.vue?vue&type=style&index=0&id=7c8c977b&lang=scss&scoped=true"

import exportComponent from "/Users/sherinbloemendaal/projects/spb/pricetiger/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8c977b"]])

export default __exports__